import { MutationTree } from 'vuex'
import { FlowGroup } from 'simplex-flow-models';
import { OverviewState } from './state'

export interface OverviewMutations {
    ['setAllCredentials'](state: OverviewState, credentials:  Array<Record<string, any>>): void;
    ['setAllOAuth'](state: OverviewState, OAuth:  Array<Record<string, any>>): void;
    ['setAllFlows'](state: OverviewState, allFlows:  Array<Record<string, any>>): void;
    ['setStatistics'](state: OverviewState, statistics: Record<string, any>): void;
    ['setSubscription'](state: OverviewState, subscription: Record<string, any>): void;
    ['setAllEmails'](state: OverviewState, allEmails: Array<string> | boolean): void;
    ['setAllEmailObjects'](state: OverviewState, allEmails: Array<string> | boolean): void;
    ['setAllEndpoints'](state: OverviewState, allEndpoints: Array<Record<string, any>>): void;
    ['setAllManualStartedLogs'](state: OverviewState, allManualStartedLogs: Array<Record<string, any>>): void;
    ['setManualStartedLogsThisMonth'](state: OverviewState, manualStartedLogsThisMonth: Array<Record<string, any>>): void;
    ['setFlowsOrder'](state: OverviewState, order: string[]): void;
    ['setFlowGroups'](state: OverviewState, groups: FlowGroup[]): void;
    ['setSchedulesOrder'](state: OverviewState, scheduledFlowsOrder: string[]): void;
    ['setCredentialsOrder'](state: OverviewState, order: string[]): void;
    ['setWorkingHours'](state: OverviewState, workingHours: { startTime: string; endTime: string }): void;
    ['setLastRuns'](state: OverviewState, lastRuns: Array<Record<string, any>>): void;
    ['setRunningFlows'](state: OverviewState, runningFlows: Array<Record<string, any>>): void;
    ['setQueuedFlows'](state: OverviewState, queuedFlows: Array<Record<string, any>>): void;
    ['setFuturePlannedDate'](state: OverviewState, futurePlannedDate: { plannedDate: string; plannedDateReadable: string } | null): void;
    ['setFuturePlannedDates'](state: OverviewState, futurePlannedDates: { nextRuns: Array<{ runNumber: number; plannedDate: string; plannedDateReadable: string }> } | null): void;
    ['setLicenseData'](state: OverviewState, licenseData: Record<string, any>): void;
    ['setLicenseHistory'](state: OverviewState, licenseHistory: Array<Record<string, any>>): void;
}

export const overviewMutations: MutationTree<OverviewState> & OverviewMutations = {
    ['setAllCredentials'](state: OverviewState, credentials: Array<Record<string, any>>): void {
        state.allCredentials = credentials;
    },
    ['setAllOAuth'](state: OverviewState, OAuth: Array<Record<string, any>>): void {
        state.allOAuth = OAuth;
    },
    ['setAllFlows'](state: OverviewState, allFlows: Array<Record<string, any>>): void {
        // Archived flows don't count anywhere (license, planning, selects), so they live in their own list.
        state.allFlows = allFlows.filter(flow => !flow.archived);
        state.archivedFlows = allFlows.filter(flow => flow.archived);
    },
    ['setStatistics'](state: OverviewState, statistics: Record<string, any>): void {
        state.statistics = statistics;
    },
    ['setSubscription'](state: OverviewState, subscription: Record<string, any>): void {
        state.subscription = subscription;
    },
    ['setAllEmails'](state: OverviewState, allEmails: Array<string> | boolean): void {
        state.allEmails = allEmails;
    },
    ['setAllEmailObjects'](state: OverviewState, allEmails: Array<string> | boolean): void {
        state.allEmails = allEmails;
    },
    ['setAllEndpoints'](state: OverviewState, allEndpoints: Array<Record<string, any>>): void {
        state.allEndpoints = allEndpoints;
    },
    ['setAllManualStartedLogs'](state: OverviewState, allManualStartedLogs: Array<Record<string, any>>): void {
        state.allManualStartedLogs = allManualStartedLogs;
    },
    ['setManualStartedLogsThisMonth'](state: OverviewState, manualStartedLogsThisMonth: Array<Record<string, any>>): void {
        state.manualStartedLogsThisMonth = manualStartedLogsThisMonth;
    },
    ['setFlowsOrder'](state: OverviewState, order: string[]): void {
        state.flowsOrder = order;
    },
    ['setFlowGroups'](state: OverviewState, groups: FlowGroup[]): void {
        state.flowGroups = groups;
    },
    ['setSchedulesOrder'](state: OverviewState, scheduledFlowsOrder: string[]): void {
        state.schedulesOrder = scheduledFlowsOrder;
    },
    ['setCredentialsOrder'](state: OverviewState, credentialsOrder: string[]): void {
        state.credentialsOrder = credentialsOrder;
    },
    ['setWorkingHours'](state: OverviewState, workingHours: { startTime: string; endTime: string }): void {
        state.workingHours = workingHours;
    },
    ['setLastRuns'](state: OverviewState, lastRuns: Array<Record<string, any>>): void {
        state.lastRuns = lastRuns;
    },
    ['setRunningFlows'](state: OverviewState, runningFlows: Array<Record<string, any>>): void {
        state.runningFlows = runningFlows;
    },
    ['setQueuedFlows'](state: OverviewState, queuedFlows: Array<Record<string, any>>): void {
        state.queuedFlows = queuedFlows;
    },
    ['setFuturePlannedDate'](state: OverviewState, futurePlannedDate: { plannedDate: string; plannedDateReadable: string } | null): void {
        state.futurePlannedDate = futurePlannedDate;
    },
    ['setFuturePlannedDates'](state: OverviewState, futurePlannedDates: { nextRuns: Array<{ runNumber: number; plannedDate: string; plannedDateReadable: string }> } | null): void {
        state.futurePlannedDates = futurePlannedDates;
    },
    ['setLicenseData'](state: OverviewState, licenseData: Record<string, any>): void {
        state.licenseData = licenseData;
    },
    ['setLicenseHistory'](state: OverviewState, licenseHistory: Array<Record<string, any>>): void {
        state.licenseHistory = licenseHistory;
    }
}